function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c51be3512c32becf5c3cb2669da2620f7{fill:none;}.sfsgaggr49637ndfm{fill:currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.25 0.25)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "c51be3512c32becf5c3cb2669da2620f7",
  width: 26,
  height: 27,
  transform: "translate(0.25 -0.25)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "c51be3512c32becf5c3cb2669da2620f7",
  width: 26,
  height: 27,
  transform: "translate(0.25 -0.25)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.745 3.75)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "sfsgaggr49637ndfm",
  cx: 4,
  cy: 4.5,
  rx: 4,
  ry: 4.5,
  transform: "translate(4.505)"
}), /*#__PURE__*/React.createElement("path", {
  className: "sfsgaggr49637ndfm",
  d: "M9.772,14C6.845,14,1,15.469,1,18.386v1.1a1.1,1.1,0,0,0,1.1,1.1H17.448a1.1,1.1,0,0,0,1.1-1.1v-1.1C18.545,15.469,12.7,14,9.772,14Z",
  transform: "translate(-1 -2.772)"
}), /*#__PURE__*/React.createElement("path", {
  className: "sfsgaggr49637ndfm",
  d: "M20.483,10.29V7H18.29v3.29H15v2.193h3.29v3.29h2.193v-3.29h3.29V10.29Z",
  transform: "translate(0.351 -3.448)"
})));

function SvgAddPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.87f80283.svg";
export { ForwardRef as ReactComponent };